import styled, { css } from 'styled-components';

import { mediaWideNavless, mediaTopBarVisible } from '@xing-com/layout-tokens';
import { spaceL, spaceXXL } from '@xing-com/tokens';

export const Box = styled.div<{ $isSearchAndShuffle?: boolean }>`
  position: relative;
  z-index: 2;
  max-width: 768px;
  margin: 0 auto;
  padding-bottom: ${spaceXXL};

  @media ${mediaWideNavless} {
    max-width: 972px;
  }

  @supports (hanging-punctuation: first) and (font: -apple-system-body) and
    (-webkit-appearance: none) {
    z-index: auto;
  }

  ${({ $isSearchAndShuffle }) =>
    $isSearchAndShuffle &&
    css`
      max-width: 100vw;

      @media ${mediaWideNavless} {
        max-width: 100vw;
      }

      @media ${mediaTopBarVisible} {
        padding-bottom: ${spaceL};
      }
    `};
`;
